import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./translation/en.json";
import translationAR from "./translation/ar.json";
import translationFR from "./translation/fr.json";
import translationES from "./translation/es.json";
import translationPT from "./translation/pt.json";
import translationDT from "./translation/dt.json";

const getLanguage = () => {
  const savedLanguage = localStorage.getItem("language");
  return savedLanguage || "fr";
};

const saveLanguage = (language) => {
  localStorage.setItem("language", language);
};

const resources = {
  en: { translation: translationEN },
  ar: { translation: translationAR },
  fr: { translation: translationFR },
  es: { translation: translationES },
  pt: { translation: translationPT },
  dt: { translation: translationDT },
};

i18n
  .use(LanguageDetector) 
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguage(),
    fallbackLng: "fr", 
    interpolation: {
      escapeValue: false, 
    },
    react: {
      useSuspense: false, 
    },
  });

i18n.on("languageChanged", (lng) => {
  saveLanguage(lng);
});

export default i18n;
